import type React from "react";
import { ReactComponent as Svg } from "./assets/touch-id.svg";
import * as styles from "./Icon.module.scss";

type TouchIdProps = React.SVGProps<SVGSVGElement>;

export const TouchId = ({ className, ...props }: TouchIdProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
